import * as R from 'ramda';

function MessageSendForm({ emails, setEmails, templates, selectedTemplateId, setSelectedTemplateId, error, onClick }) {
    return (
        <div style={{ minWidth: '45%' }}>
            <div className="form-group">
                <label> Select Message Template </label>
                <select
                    value={selectedTemplateId}
                    onChange={e => {
                        setSelectedTemplateId(e.target.value)
                    }}
                >
                    { templates.map(template => (
                        <option key={template.templateId} value={template.templateId}>
                            { template.templateName}
                        </option>
                    ))}
                </select>
            </div>
            <div className="form-group">
                <label>Emails</label>
                <textarea
                    rows="30"
                    cols="100"
                    className="form-control"
                    id="emails"
                    value={emails}
                    onChange={(e) => setEmails(e.target.value)}
                />
            </div>
            <button
                onClick={() => onClick()}
                disabled={!R.isNil(error)}
                className="btn btn-primary"
            >
                Submit
            </button>
        </div>
    )
}

export default MessageSendForm;